// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

// Section for import custom components --------------------------------------------------------------------------------

// Section for render component ----------------------------------------------------------------------------------------
// Section for type definition -----------------------------------------------------------------------------------------
import MansionOverviewDescriptionPropsData from '@/types/components/MansionDetail/MansionOverviewDescriptionPropsData';

type MansionOverviewDescriptionProps = {
  mansionOverviewDescription: MansionOverviewDescriptionPropsData;
};

export default function MansionOverviewDescription(props: MansionOverviewDescriptionProps) {
  const { mansionOverviewDescription } = props;
  return (
    <Box id="app-content-detail-special_contents">
      <Box id="app-content-detail_mansion_features" className="max-md:mt-4 ">
        <Container className="md:max-w-7xl md:w-full md:mx-auto max-md:mx-0 mb-16 max-md:mb-12 md:px-24 max-md:px-5">
          <Typography
            component="h2"
            variant="h2"
            className="border-solid border-l-2 border-rf-black relative mb-6 max-md:mb-5 pl-4 text-lg font-bold before:absolute before:top-1 before:left-[-16px]"
          >
            {mansionOverviewDescription.title}
          </Typography>
          <Typography className="text-base">{mansionOverviewDescription.description}</Typography>
        </Container>
      </Box>
    </Box>
  );
}
